import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';

export const state = () => ({
    items: [],
});

export const getters = {
    items: state => state.items,
};

export const mutations = {
    ADD_ITEM(state, item) {
        const index = state.items.findIndex(i => i.entity_id === item.entity_id && i.type === item.type);

        if (~index) {
            state.items.splice(index, 1, cloneDeep(item));
        } else {
            state.items.push(cloneDeep(item));
        }
    },

    REMOVE_ITEM(state, { entity_id, type }) {
        state.items = state.items.filter(item => !(item.type === type && item.entity_id === entity_id));
    }
};

export const actions = {
    async index({ commit }, type) {
        let items = await axios.$get('/v3/accounts/pins', { params: { type } });

        items = items.map(item => ({ entity_id: item, type }));
        items.forEach(item => commit('ADD_ITEM', item));

        return items;
    },

    async create({ commit }, { entity_id, type }) {
        commit('ADD_ITEM', { entity_id, type });

        await axios.$post('/v3/accounts/pins', { entity_id, type });
    },

    async remove({ commit }, { entity_id, type }) {
        commit('REMOVE_ITEM', { entity_id, type });

        await axios.$delete(`/v3/accounts/pins`, { params: { entity_id, type } });
    }
};
